<template>
  <div class="big" v-if="list.length">
    <div class="bottom">
      <div>
        <a
          v-for="(item, index) in list"
          href="javascript:;"
          :key="index"
          :class="index == currentIndex ? 'active' : ''"
          @mouseenter="stopBanner(index)"
          @mouseleave="startBanner(index)"
          @click="goUrl(item)"
          >{{ item.title }}</a
        >
      </div>
    </div>
    <swiper ref="mySwiper" :options="swiperOptions"  :auto-play="true">
      <swiper-slide  v-for="(item, index) in list" :key="index">
        <img :src="item.image" :alt="'百生跃'+item.title" @click="goUrl(item)"/>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "carrousel",
  data() {
    return {
      list: [],
      currentIndex: 0,
      swiperOptions: {
        grabCursor: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        },
        loop: true,
        speed: 1000
      }
    }
  },
  updated() {
      this.$refs.mySwiper.$swiper.on("slideChangeTransitionStart", () => {
        let activeIndex = this.$refs.mySwiper.$swiper.activeIndex;
        if(activeIndex == this.list.length + 1){
          activeIndex = 1
          this.currentIndex = activeIndex - 1;
        } else{
          this.currentIndex = activeIndex - 1;
        }     
      });
  },
  methods: {
    stopBanner (index) {
      this.currentIndex = index;
      this.$refs.mySwiper.$swiper.slideTo(index + 1, 1000, false)
      this.$refs.mySwiper.$swiper.autoplay.stop()
    },
    startBanner (index) {
      this.$refs.mySwiper.$swiper.autoplay.start()
    },
    goUrl(item){
      if(item.link){
        window.location.href = item.link
      }else{
            
      }
    }
  },
  created () {
    this.$api.homepage.banner({
      type : 0
    }).then(res=>{
        this.list=res.data
    })
  },
};
</script>

<style lang="less" scoped>
.big {
  width: 1920px;
  height: 760px;
  position: relative;
}
.bottom {
  width: 100%;
  height: 50px;
  background: rgba(0, 56, 113, 0.5);
  position: absolute;
  bottom: 0px;
  z-index: 99;
  div {
    width: 80%;
    margin: auto;
    display: flex;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    color: #f9f9f9;
    justify-content: center;
    a {
      width: 250px;
      color: #fff;
      &.active {
        background: url("../images/three.png") no-repeat;
        background-position: center;
        background-size: contain;
        width: 250px;
        height: 59px;
        z-index: 10;
        margin-top: -9px;
        line-height: 65px;
        color:#003871;
      }
    }
  }
}
.swiper-slide {
  width: 1920px;
  height: 760px;
  img {
    width: 1920px;
    height: 760px;
  }
}
</style>